const DROPDOWN = {
    onReady() {
        let nodes = document.querySelectorAll('.dropdown');
        nodes.forEach(node => {
            node.addEventListener('click', event => {
                nodes.forEach(node => {
                    (node !== event.target.closest('.dropdown')) && node.classList.remove('is-active');
                });
                node.classList.toggle('is-active');
            });
        });
    }
}